<!-- <template>
  <div class="autor_mobile">
    <p class="font_1_400_Kreadon_Regular color_violet">Авторы</p>
     <div class="all_autor_article">
              <img
                class="img_autor_article_small"
                src="@/assets/elements/img_autor_article.svg"
              />
              <div class="box_text_all_autor_article">
                <p class="font_1_400_Kreadon_Regular">Немчицкий Кирилл</p>
                <p class="font_1_400_Kreadon_Regular color_violet">
                  Frontend-разработчик
                </p>
              </div>
            </div> 
    <div class="all_autor_article">
      <img
        class="img_autor_article_small"
        src="@/assets/elements/img_autor_article.svg"
        alt="автор"
      />
      <div class="box_text_all_autor_article">
        <p class="font_1_400_Kreadon_Regular">Немчицкий Кирилл</p>
        <p class="font_1_400_Kreadon_Regular color_violet">SEO-специалист</p>
      </div>
    </div>
  </div>
</template> -->
<template>
  <div class="autor_mobile">
    <p class="font_1_400_Kreadon_Regular color_violet">
      {{ authors.length > 1 ? "Авторы" : "Автор" }}
    </p>
    <div
      class="all_autor_article"
      v-for="(author, index) in authors"
      :key="index"
    >
      <img
        class="img_autor_article_small"
        :src="author.image"
        :alt="author.name"
      />
      <div class="box_text_all_autor_article">
        <p class="font_1_400_Kreadon_Regular">{{ author.name }}</p>
        <p class="font_1_400_Kreadon_Regular color_violet">
          {{ author.position }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    authors: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
